// import React from "react";
import { Link } from 'react-router-dom';
import '../style/Portfolio.css';


export default function Portfolio() {
    return (
        <>
            <section className="section-5">
                <h1 className="text-center pt-5">Our Works</h1>
                <div className="nava">
                    <a className='lead' href="#">Furniture</a>
                    <a className='lead' href="#">Furniture</a>
                    <a className='lead' href="#">Furniture</a>
                    <a className='lead' href="#">Furniture</a>
                </div>
                <div className="sec-5 ">
                    <div className="boxbox-5 bx-1">
                        <h1>New house interior</h1>
                    </div>
                    <div className="boxbox-5 bx-2">
                    <h1>New house interior</h1>
                    </div>
                    <div className="boxbox-5 bx-3">
                    <h1>New house interior</h1>
                    </div>
                    <div className="boxbox-5 bx-1 ">
                    <h1>New house interior</h1>
                    </div>
                    <div className="boxbox-5 bx-2">
                    <h1>New house interior</h1>
                    </div>
                    <div className="boxbox-5 bx-3">
                    <h1>New house interior</h1>
                    </div>
                    <div className="boxbox-5 bx-1">
                    <h1>New house interior</h1>
                    </div>
                    <div className="boxbox-5 bx-2">
                    <h1>New house interior</h1>
                    </div>
                    <div className="boxbox-5 bx-3 bx-">
                    <h1>New house interior</h1>
                    </div>

                </div>
            </section>
            <footer className='  footer'>
                <div className="foot ">
                    <h1 className="mt-5 fw-bold  pt-5">Biz bilan hamkor bo’ling</h1>
                    <p className="text-secondary lead">Biz sifatli va ajoyib modellarni sizga taqdim qilamiz</p>
                    <div className="l">
                        <Link className="but mt-5" to="/order">Order A Project</Link>
                    </div>
                </div>
                <div className="foot-  d-flex justify-content-between">
                    <img src={require("../dizipro.png")} alt="Error" />
                    <div className="nav-menu">
                        <Link className="nav-item text-light  " to="/">Home</Link>
                        <Link className="nav-item text-light  " to="/portfolio">Portfolio</Link>
                        <Link className="nav-item text-light  " to="/order">Order A Project</Link>
                        <Link className="nav-item text-light  " to="/paid">Paid Courses</Link>
                        <Link className="nav-item text-light  " to="/profil">Profil</Link>
                    </div>
                    <div className="i">
                        <i class="fa-brands fa-instagram"></i>
                        <i class="fa-brands fa-telegram"></i>
                        <i class="fa-brands fa-facebook"></i>
                    </div>
                </div>
            </footer>
        </>
    )
}